const isStaff = () => {
    return window.location.pathname.includes('staff');
};

export default isStaff;
